import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppUtils } from 'src/app/helpers/app.utils';
import { PageUrls } from 'src/app/helpers/page-urls';
import { TableModel } from 'src/app/models/table.model';
import { RawImageService } from '../../../services/raw.image.service';
import { PagedPendingGroupedModel } from '../../../models/paged.pending.grouped.model';
import { Router } from '@angular/router';

@Component({
    selector: 'app-image-pending-grouped',
    templateUrl: './raw.image.pending.grouped.component.html',
    styleUrls: ['./raw.image.pending.grouped.component.scss']
})
export class RawImagePendingGroupedComponent implements OnInit {
    subscriptions = new Array<Subscription>();
    tableModel = new TableModel();
    pagedPendingGroupedDetails = new PagedPendingGroupedModel();
    totalRecords = 0;
    isModelLoaded = false;

    get urls() {
        return PageUrls;
    }

    constructor(private ngxSpinnerService: NgxSpinnerService,
        private toastr: ToastrService,
        private rawImageService: RawImageService,
        private router: Router) {
    }

    ngOnInit() {
        this.tableModel = new TableModel();
        this.totalRecords = 0;
        this.subscriptions = [];

        this.initSubscribers();
        this.getImages();

    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getImages());
        this.subscriptions.push(subscription);
    }

    getImages = () => {
        setTimeout(() => {
            this.ngxSpinnerService.show();
        });
        this.rawImageService.pendingGroupedList(this.tableModel)
            .subscribe(data => {
                this.pagedPendingGroupedDetails = data;
                this.totalRecords = data.totalCount;
                this.ngxSpinnerService.hide();
                this.isModelLoaded = true;
            }, error => {
                this.ngxSpinnerService.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    accept(unixTimeStamp: number): void {
        if (!confirm('Are you sure you want to accept these images?')) {
            return;
        }
        this.ngxSpinnerService.show();
        this.rawImageService.accept(unixTimeStamp).subscribe(
            () => {
                this.ngxSpinnerService.hide();
                this.getImages();
                this.toastr.success('Aceepted successfully.');
            }, error => {
                this.ngxSpinnerService.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    reject(unixTimeStamp: number): void {
        if (!confirm('Are you sure you want to reject these images?')) {
            return;
        }
        this.ngxSpinnerService.show();
        this.rawImageService.reject(unixTimeStamp).subscribe(
            () => {
                this.ngxSpinnerService.hide();
                this.getImages();
                this.toastr.success('Rejected successfully.');
            }, error => {
                this.ngxSpinnerService.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    openImageCount(unixTimeStamp: number) {
        setTimeout(() => {
            this.router.navigateByUrl(`${PageUrls.Editor.RawImageManage}?unixTimeStamp=${unixTimeStamp}`);
        });
    }
}
